// removed by extract-text-webpack-plugin
module.exports = {"container":"_2cE6zVitYS0ncuHI1zYLfW","row":"_3JvEZGvud_PwUMCw1sApu8","textDanger":"_3LaZFgfAePGig47yCRfPaI","spaceLeft":"_1Jd1RNoGxfK5JqJCIkTKLD","spaceBoth":"_3V4QE8Goj4sSHNp7J5F4ed","spaceRight":"_33Rr85Pxs96qNQDn_inA7R","rowTabs":"_2lJaHu5OepkTiA9cVmjFqi","tabs":"_1M5QnnC6NLM8bxLETmcd3K","tab":"_2lKasbsOzWaySChtA2Z5wC","active":"_38VBHMHb-OUTYoT-gp8OPu","tabBig":"_2mjwP4cLy2AKdytiVvZzXl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisTabs.scss
// module id = 1316
// module chunks = 0